import type { Persona } from '@experiences/interfaces';

export function getPersonaFromBundleCode(bundleCode: string): Persona {
    switch (bundleCode) {
        // RPA Developer
        case 'RPADEVNU':
        case 'RPADEVCU':
        case 'RPADEVPRONU':
        case 'RPADEVPROCU':
        case 'PRONU':
        case 'PMD': return 'RPA_DEVELOPER';

        // Citizen developer or BAP
        case 'CTZDEVNU':
        case 'BASICNU':
        case 'PLUSNU':
        case 'CBNU':
        case 'CTZDEVCU': return 'CITIZEN_DEV';

        // Autopilot/Automation Express
        case 'AXPNU':
        case 'AKIT': return 'AUTOMATION_EXPRESS_USER';

        // Business User
        case 'ATTUCU':
        case 'ACNU':
        case 'ACCU':
        case 'BUSNU':
        case 'ATTUNU': return 'BUSINESS_USER';

        // TPM
        case 'PMBU':
        case 'IDU':
        case 'ANL': return 'BUSINESS_ANALYST';

        // Tester
        case 'APPTESTNU':
        case 'APPTESTDEVNU':
        case 'TSTNU':
        case 'TSTDEVPRONU': return 'TESTER';

        default: return 'UNKNOWN';
    }
}
